<template>
  <div>
      <header>
        <p>
          三级页面
        </p>
      </header>
      <div class="body">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="操作日志一" force-render>
            操作日志一
          </a-tab-pane>
          <a-tab-pane key="2" tab="操作日志二" force-render>
            操作日志二
          </a-tab-pane>
          <a-tab-pane key="3" tab="操作日志三" force-render>
            操作日志三
          </a-tab-pane>
        </a-tabs>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
header{
  height: 40px;
  width: 100%;
  p{
    font-size: $sixteen-PX;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);    
  }
}
.body{
  margin-top: $sixteen-PX;
  /deep/ .ant-tabs-nav-wrap{
    .ant-tabs-tab{
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
    .ant-tabs-tab-active{
      color: $tab-color;
    }
    .ant-tabs-ink-bar{
      transform:translate3d(13px, 0px, 0px);
      width: 85px;
      background-color: $tab-color;
    }
  }
}
</style>